import Service from './abstract';
import _ from 'lodash';

const basePath = '/recharges';

const defaultHealthWith = {
    with: 'rechargesEnabled'
};
class Recharges extends Service {
    constructor () {
        super('recharges');
    }

    getById (id) {
        return this.get({
            // TODO fix base url. When cross domain resolve for PUT method
            url: `${basePath}/recharges/${id}`,
            qs: {
                tiny: false
            }
        });
    }

    getProducts (options = {}) {
        return this.get({
            url: `${basePath}/products`,
            qs: _.defaultsDeep({ tiny: false }, options)
        });
    }

    getHealth () {
        return this.get({
            url: `${this.basePath}/health`,
            qs: defaultHealthWith
        });
    }
}

export default new Recharges();
